import { languages } from '../../data/constants';

export class Controller {

    /** @ngInject */
    constructor($translate) {
        this.$translate = $translate;
    }

    $onInit() {
        this.languages = languages;
    }

    flag(langKey) {
        return require(`./flags/${langKey}.png`);
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/language-switcher/language-switcher.controller.js